/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface VerifyChallenge200Response
 */
export interface VerifyChallenge200Response {
    /**
     * 以降のリクエストで x-challenge-success-token ヘッダに乗せて付与する。 
     * @type {string}
     * @memberof VerifyChallenge200Response
     */
    'challengeSuccessToken': string;
    /**
     * challengeSuccessToken の有効期限（5分固定。ログアウトとは独立して保持される＝ 時間経過のみで失効し、ログアウトでは失効しない） 
     * @type {string}
     * @memberof VerifyChallenge200Response
     */
    'expiresAt': string;
    /**
     * どの sudo-mode 操作に対するチャレンジかを表す。 card_information=カード詳細, user_profile=メールアドレス変更, user_invitation=ユーザ招待/一括招待 
     * @type {string}
     * @memberof VerifyChallenge200Response
     */
    'scope': VerifyChallenge200ResponseScopeEnum;
}

export const VerifyChallenge200ResponseScopeEnum = {
    cardInformation: 'card_information',
    userProfile: 'user_profile',
    userInvitation: 'user_invitation'
} as const;

export type VerifyChallenge200ResponseScopeEnum = typeof VerifyChallenge200ResponseScopeEnum[keyof typeof VerifyChallenge200ResponseScopeEnum];


